import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTripleStars = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 17 17",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M5.6582 8.12659L9.32614 9.45864L10.6582 13.1266L11.9902 9.45864L15.6582 8.12659L11.9902 6.79453L10.6582 3.12659L9.32614 6.79453L5.6582 8.12659Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.28125 4.15588L5.38163 4.5555L5.78125 5.65588L6.18086 4.5555L7.28125 4.15588L6.18086 3.75627L5.78125 2.65588L5.38163 3.75627L4.28125 4.15588Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.41406 12.3289L4.24803 12.9949L4.91406 14.8289L5.58008 12.9949L7.41406 12.3289L5.58008 11.6629L4.91406 9.82892L4.24803 11.6629L2.41406 12.3289Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgTripleStars);
export default ForwardRef;
